<div class="card hover-show w-100 overflow-auto">
    <div class="position-absolute start-0" style="top: 2.5rem" [ngClass]="{'opacity-50': !isActive()}">
        <app-label [label]="connection.info.marketSegment" [translateContent]="false"></app-label>
    </div>
    <div class="card-body overflow-hidden">
        <ng-container *ngIf="selecting else normalView">
            <div class="form-check form-switch position-absolute top-0 start-0 ms-2 mt-2">
                <input class="form-check-input mt-0" [(ngModel)]="entity['selected']"
                       (ngModelChange)="toggleSelectedItem($event)" type="checkbox">
            </div>
        </ng-container>
        <ng-template #normalView>
            <app-confirmation-toggle *ngIf="appContext.isManagerForEntity(entity)">
                <div class="modal-content">
                    <div class="modal-header">
                        <h3 class="modal-title">Remove connection</h3>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body mt-0 pb-2">
                        <p *ngIf="entity.connection.meters.length > 0" class="text-danger">
                            This connection has active meters. Deleting it will also remove all associated meters and
                            meter data.
                        </p>
                        <p>Are you sure you want to remove this connection?</p>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <a type="button" class="btn btn-secondary"
                           data-bs-dismiss="modal">Cancel</a>
                        <button type="button" class="btn btn-primary" (click)="deleteConnection()"
                                data-bs-dismiss="modal">
                            Remove connection
                        </button>
                    </div>
                </div>

                <button type="button" class="btn position-absolute top-0 start-0 to-show" role="button"
                        aria-expanded="false">
                    <i class="bi bi-trash"></i>
                </button>
            </app-confirmation-toggle>
            <button *ngIf="appContext.isManagerForEntity(entity)" type="button" class="btn position-absolute top-0 start-0 ms-2 to-show" role="button"
                    style="left: 24px !important;" aria-expanded="false" (click)="openMoveConnectionModal(entity)"
                    data-bs-toggle="tooltip" data-bs-placement="top" title="Move connection to another location">
                <i class="bi bi-arrow-left-right"></i>
            </button>
            <button type="button" class="btn position-absolute top-0 end-0 to-show" role="button"
                    style="right: 24px !important;" aria-expanded="false" (click)="openConnectionGraph()">
                <i class="bi bi-bar-chart-line"></i>
            </button>
            <button *ngIf="appContext.isManagerForEntity(entity)" type="button"
                    class="btn position-absolute top-0 end-0 to-show" role="button"
                    aria-expanded="false" (click)="openConnectionDetails()">
                <i class="bi bi-pencil"></i>
            </button>
        </ng-template>
        <div [ngClass]="{'opacity-50': !isActive()}">
            <div class="text-center mb-3">
                <h2 class="card-title notranslate">
                    <app-connection-image [connectionType]="connection.info.connectionType"></app-connection-image>
                    {{ connection.info.code }}
                </h2>
                <div *ngIf="!isActive()" class="mb-3">
                    <span class="badge bg-danger rounded-pill ">Inactive</span>
                </div>
                <h5 class="text-muted notranslate d-flex align-items-center justify-content-center gap-2">
                    <span>{{ entity.location.info.name }}</span>
                    <button *ngIf="hasUploadAccess" type="button" class="btn btn-link btn-sm text-muted p-0 lh-1 flex-shrink-0 location-uploads-link"
                            (click)="openUploadHistory()" [title]="uploadHistoryTitle()" [attr.aria-label]="uploadHistoryTitle()">
                        <i class="bi bi-clock-history" aria-hidden="true"></i>
                    </button>
                </h5>
                <span *ngIf="connection.info.label" class="text-muted notranslate text-truncate">
                    <i class="bi bi-tag"></i>
                    {{ connection.info.label }}
                </span>
            </div>
            <hr class="card-divider m-0 mb-3">

            <div *ngIf="linkedContracts().length > 0" [style.max-height.px]="200"
                 class="list-group-flush list-group overflow-y-auto overflow-x-hidden">
                <div *ngFor="let linkedContract of linkedContracts(); trackBy: trackByLinkedContractId"
                     class="list-group-item py-3">
                    <div class="row">
                        <div class="col-auto">
                            <i class="bi me-2 bi-paperclip"></i>
                        </div>
                        <div class="col text-truncate notranslate">
                            <small>{{ getContractDescription(linkedContract.contractId) | async }}</small>
                        </div>
                        <ng-container *ngIf="appContext.isAdminOrIntermediary()">
                            <div class="col-auto my-3">
                                <button type="button" class="btn position-absolute top-0 end-0 to-show"
                                        style="right: 24px !important;"
                                        role="button" aria-expanded="false" (click)="updateLinkedContract(linkedContract)">
                                    <i class="bi bi-pencil"></i>
                                </button>
                            </div>
                            <div class="col-auto my-3">
                                <app-confirmation-toggle *ngIf="allowContractDelete(linkedContract)">
                                    <div class="modal-content">
                                        <div class="modal-header">
                                            <h3 class="modal-title">Remove contract</h3>
                                            <button type="button" class="btn-close"
                                                    data-bs-dismiss="modal"
                                                    aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            <p>Are you sure you want to remove this contract?</p>
                                        </div>
                                        <div class="modal-footer justify-content-between">
                                            <a type="button" class="btn btn-secondary"
                                               data-bs-dismiss="modal">Cancel</a>
                                            <button type="button" class="btn btn-primary"
                                                    (click)="unlinkContract(linkedContract)" data-bs-dismiss="modal">
                                                Remove contract
                                            </button>
                                        </div>
                                    </div>

                                    <button type="button"
                                            class="btn position-absolute top-0 end-0 to-show"
                                            role="button" aria-expanded="false">
                                        <i class="bi bi-trash"></i>
                                    </button>
                                </app-confirmation-toggle>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
            <hr *ngIf="linkedContracts().length > 0" class="card-divider m-0 mb-3">
            <div class="list-group-flush list-group overflow-y-auto overflow-x-hidden"
                 [style.max-height.px]="200">
                <div *ngFor="let meter of meters | async; trackBy: trackByMeterId"
                     class="list-group-item py-3 meter-list-item">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <i class="bi me-2 bi-speedometer2"></i>
                        </div>
                        <div class="col text-truncate notranslate">
                            <small>{{ refDataUtils.meterFormatter(meter) }}</small>
                        </div>
                        <div *ngIf="allowMeterEdit(meter) || allowMeterSplit(meter) || allowMeterDelete(meter)"
                             class="col-auto align-items-center gap-1 meter-row-actions">
                            <button *ngIf="allowMeterEdit(meter)" type="button"
                                    class="btn btn-sm" role="button" aria-expanded="false"
                                    aria-label="Edit meter" (click)="openMeterDetails(meter)">
                                <i class="bi bi-pencil"></i>
                            </button>
                            <button *ngIf="allowMeterSplit(meter)" type="button"
                                    class="btn btn-sm" role="button" aria-expanded="false"
                                    aria-label="Configure meter split" title="Configure meter split"
                                    (click)="openMeterSplit(meter)">
                                <i class="bi bi-diagram-3"></i>
                            </button>
                            <app-confirmation-toggle *ngIf="allowMeterDelete(meter)">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h3 class="modal-title">Remove meter</h3>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <p>Are you sure you want to remove this meter?</p>
                                    </div>
                                    <div class="modal-footer justify-content-between">
                                        <a type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</a>
                                        <button type="button" class="btn btn-primary" (click)="deleteMeter(meter)"
                                                data-bs-dismiss="modal">
                                            Remove meter
                                        </button>
                                    </div>
                                </div>

                                <button type="button" class="btn btn-sm"
                                        role="button" aria-expanded="false" aria-label="Remove meter">
                                    <i class="bi bi-trash"></i>
                                </button>
                            </app-confirmation-toggle>
                        </div>
                    </div>
                </div>
                <div *ngIf="appContext.isAdminOrIntermediary() && allowAddMeter()"
                     class="list-group-item py-3 pointer hover-underline"
                     (click)="openUpsertSolarEdgeMeter()">
                    <div class="row">
                        <div class="col-auto">
                            <i class="bi me-2 bi-plus-circle"></i>
                        </div>
                        <div class="col text-truncate"><small>Add new solaredge meter</small></div>
                    </div>
                </div>
                <div *ngIf="appContext.isAdminOrIntermediary()" class="list-group-item py-3 pointer hover-underline"
                     (click)="linkContract()">
                    <div class="row">
                        <div class="col-auto">
                            <i class="bi me-2 bi-plus-circle"></i>
                        </div>
                        <div class="col text-truncate"><small>Link contract</small></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
